import {
  Component,
  OnInit,
} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import * as fromAuthStore from '@app/auth/store';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  rolesLoaded$: Observable<any>;
  currentUser$: Observable<any>;
  currentDate = new Date();

  constructor(
    private authStore: Store<fromAuthStore.State>,
  ) {
  }

  ngOnInit(): void {
    this.currentUser$ = this.authStore.select(fromAuthStore.getUser);
    this.rolesLoaded$ = this.authStore.select(fromAuthStore.getRolesLoaded);
  }
}
